<template>
  <div id="content"
       class="container">
    <header>
      <div class="integralBreadcrumb">
        <div class="integralBreadcrumb-item"
             @click="routerHandle('onlineTraining')">首页</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item"
             @click="routerHandle('bookList')">工业文库</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item"
             v-if="dataForm"
             @click="routerHandle()">{{dataForm.bookName}}</div>
      </div>
    </header>
    <main>
      <div class="book-info"
           v-if="dataForm">
        <div class="book-img">
          <div id="magnifier"
               @mouseover="(e)=>imgMouseover(e)"
               @mouseout="(e)=>imgMouseout(e)"
               @mousemove="(e)=>imgMousemove(e)">
            <div class="small_img">
              <img width="550px"
                   height="357px"
                   :src="dataForm.url?dataForm.url: imgUrl1" />
            </div>
            <div class="big_img">
              <img width="1650px"
                   height="1071px"
                   :src="dataForm.url?dataForm.url:'/static/img/bitmap_en.png'" />
            </div>
            <span class="float"></span>
          </div>
          <div class="book-detail-one">
            <ul>
              <li>
                <p class="number">{{dataForm.salesVolumes?dataForm.salesVolumes:0}}</p>
                <p class="color-999">购买数</p>
              </li>
              <li style="width:1px;height:0.5px;margin-top:40px;background:#eee"></li>
              <li>
                <p class="number"></p>
                <p class="color-999 book-type">{{dataForm.bookType === 1?'电子书':'实体书'}}</p>
              </li>
              <li style="width:1px;height:0.5px;margin-top:40px;background:#eee"></li>
              <li>
                <p class="number">{{dataForm.viewCount}}</p>
                <p class="color-999">浏览数</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="book-detail-two">
          <div class="book-right-top">
            <h2>{{dataForm.bookName}}</h2>
            <div class="book-author">
              <span>作者：中控培训部</span>
            </div>
            <div class="book-author"
                 v-if="dataForm.bookType === 1">
              <span v-if="dataForm.loseTime">课程有效期：从购买之日起{{dataForm.loseTime}}天</span>
              <span v-if="dataForm.endTime">课程到期时间：{{dataForm.endTime}}</span>
            </div>
            <div class="book-author">咨询电话: 0571-81115196</div>
          </div>
          <div class="book-price">
            <span>价格:</span>
            <span style="color:#ff3116;font-size: 28px;">{{dataForm.currentPrice && Number(dataForm.currentPrice) > 0 ? ( '￥' + dataForm.currentPrice) : '免费'}}</span>
            <span style="margin-left:10px;text-decoration: line-through">
              <!-- 原价: -->
              <i style="text-decoration: line-through;font-style:normal">￥{{dataForm.bookPrice}}</i>
            </span>
          </div>
          <div class="book-cart book-author" v-show="!((dataForm.bookType === 1 &&(dataForm.bought || dataForm.free)) ||(dataForm.bookType === 2 &&dataForm.free))">
            <div class="shop">
              <el-button type="primary"
                         style="width:130px;background:#1D65A8;border:#1D65A8"
                         @click="handleBuy">立即购买</el-button>
              <el-button type="primary"
                         style="width:130px;height:34px;background:#fff;border:1px solid #1D65A8;color:#1D65A8"
                         @click="addShopCart">加入购物车</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="book-main">
        <div class="book-show"
             v-if="dataForm">
          <div class="show-title">
            <ul class="show-title-list">
              <li :class="currentIndex === 0 ?'show-checked':''"
                  @click="handleIndex(0)">图书简介</li>
              <li :class="currentIndex === 1 ?'show-checked':''"
                  @click="handleIndex(1)">图书预览</li>
              <li :class="currentIndex === 2 ?'show-checked':''"
                  @click="handleIndex(2)">图书评论</li>
            </ul>
          </div>
          <div class="show-content">
            <!-- 图书简介 -->
            <div class="book-introduce"
                 id="toIntroduce">
              <h6>
                <span>图书简介</span>
              </h6>
              <div class="book-con">
                <div class="train-p"
                     v-html="decodeURIComponent(dataForm.bookIntroduction)">
                </div>
              </div>
            </div>
            <div class="book-review"
                 id="review">
              <h6>
                <span>图书预览</span>
              </h6>
              <div class="bookreview"
                   v-if="dataForm.bookType===1 && dataForm.bookChapterList.length">
                <el-tree :data="dataForm.bookChapterList"
                         :props="customProps"
                         node-key="id">
                  <span class="custom-tree-node"
                        slot-scope="{ node, data }">
                    <span>{{ data.name }}</span>
                    <!-- 是免费的，或者已经购买了，直接全部可以预览 -->
                    <span v-if="dataForm.bought || dataForm.free">
                      <span style="color:green;"
                            @click="reviewBook(data)"
                            v-if="data.parentId !=null">免费预览章节</span>
                    </span>
                    <!-- 没有购买，或者不是免费的书 -->
                    <span v-else>
                      <span style="color:green;"
                            @click="reviewBook(data)"
                            v-if="data.parentId !=null && data.isFree === 0 && data.playCount">试看</span>
                      <span style="color:green;"
                            @click="reviewBook(data)"
                            v-if="data.parentId !=null && data.isFree === 0 && !data.playCount">预览章节</span>
                      <span style="color:green;"
                            @click="reviewBook(data)"
                            v-if="data.parentId !=null && data.isFree === 1">免费预览章节</span>
                    </span>
                  </span>
                </el-tree>
              </div>
              <div class="realbook"
                   v-else>暂无数据</div>
            </div>
            <!-- 图书评论 -->
            <div class="book-comment"
                 id="toComment">
              <h6>
                <span>图书评论</span>
              </h6>
              <div class="comment-info">
                <div class="comment-input">
                  <div class="comment-ava">
                    <img :src="headPhoto" />
                  </div>
                  <div class="comment-right">
                    <div class="person"></div>
                    <div class="comment-cont">
                      <el-input type="textarea"
                                placeholder="请输入评论内容(最多500字).."
                                maxlength="500"
                                v-model="dataForm.myreply"></el-input>
                    </div>
                    <div class="comment-me">
                      <el-button style="width:130px;height:34px;background:#fff;border:1px solid #1D65A8;color:#1D65A8"
                                 @click="handleComment('')">我来评价</el-button>
                    </div>
                  </div>
                </div>
                <div class="comment-list">
                  <ul>
                    <li class="comment-list-info"
                        v-for="(data,index) in dataForm.bookCommentList"
                        :key="data.id">
                      <div class="comment-ava">
                        <img :src="data.userAvatarURL?data.userAvatarURL:imgUrl" />
                      </div>
                      <div class="comment-right">
                        <div class="person">{{data.userNickname}}</div>
                        <div class="com-cont">{{data.content}}</div>
                        <div>
                          <div class="time color-999">发表于{{data.createTime}}</div>
                          <div class="good">
                            <div class="commentShow"
                                 title="评论"
                                 @click="handleClick(data.id,index)">
                              <img class="commentImg"
                                   title="评论"
                                   src="../../../../assets/img/comment_03.png" />
                              <span style="float:left;margin-left:5px">{{data.replyCount}}</span>
                            </div>
                            <div class="praiseShow"
                                 title="赞一下"
                                 @click="handleZan(data.id,4)">
                              <img class="praiseImg"
                                   title="赞一下"
                                   src="../../../../assets/img/zan_03.png" />
                              <span style="float:left;margin-left:5px">{{data.praiseCount}}</span>
                            </div>
                          </div>
                        </div>
                        <!-- 点击评论展示评论框 -->
                        <div class="comment-show"
                             v-show="data.showContent">
                          <el-input type="textarea"
                                    placeholder="请输入您要回复的文字(最多500字).."
                                    maxlength="500"
                                    style="margin-bottom:5px;"
                                    v-model="dataForm.myCommentReply"></el-input>
                          <el-button style="float:right;margin-left:5px;width:62px;line-height: 1px;height:30px;background:#fff;border:1px solid #1D65A8;color:#1D65A8;font-size:12px;"
                                     @click="handleComment(data.id,index)">回复</el-button>
                          <el-button style="float:right;width:62px;height:30px;line-height: 1px;background:#fff;border:1px solid #1D65A8;color:#1D65A8;font-size:12px;text-align:center"
                                     @click="handleCancel(index)">取消</el-button>
                        </div>
                        <!-- 评论回复显示评论的回答 -->
                        <div class="comment-all-reply"
                             v-show="data.showContent && data.commentVos.length">
                          <ul>
                            <li v-for="item in data.commentVos"
                                :key="item.id">
                              <div class="comment-ava new-img">
                                <img :src="item.userAvatarURL?item.userAvatarURL:imgUrl" />
                              </div>
                              <div class="com-reply">
                                <p>{{item.userNickname}} 评论: </p>
                                <p class="com-cont color-666">{{item.content}}</p>
                                <p class="color-999">发表时间 {{item.createTime}}</p>
                              </div>
                              <div class="com-good"
                                   title="赞一下"
                                   @click="handleZan(item.id,4)">
                                <img style="float:left;margin-left:15px;"
                                     src="../../../../assets/img/zan_03.png" />
                                <span style="float:left;margin-left:5px">{{item.praiseCount}}</span>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <!-- 分页 -->
            <div class="doclist-pagination"
                 v-if="dataForm &&dataForm.bookCommentList && (dataForm.bookCommentList === [] || dataForm.bookCommentList.length !== 0)">
              <div class="doclist-lastpage"
                   @click="jumpLastPage">上一页</div>
              <div class="doclist-omit">{{lastOmit}}</div>
              <ul>
                <li :class="item === currentPage?'pageactive':''"
                    v-for="(item, index) in pageList"
                    :key="index"
                    @click="getBookComment(item)">{{item}}</li>
              </ul>
              <div class="doclist-omit">{{nextOmit}}</div>
              <div class="doclist-nextpage"
                   @click="jumpNextPage">下一页</div>
              <div class="doclist-pagejump">
                共{{totalPage}}页，到第
                <input type="text"
                       v-model.number="jumpTargetPage" />页
              </div>
              <div class="doclist-jump"
                   @click="jumpFarPage">确定</div>
            </div>
          </div>
        </div>
        <div class="book-right">
          <!-- 猜你想买 -->
          <div class="main-book">
            <div class="tarbar-item">
              <div class="top-bg"></div>
              <div>猜你想买</div>
            </div>
            <div class="book-list">
              <div v-if="!(maybeYouWant&&maybeYouWant.length)"
                   class="no-content">没有相关数据，小编正在整理中...</div>
              <div v-else
                   class="book-name"
                   v-for="item in maybeYouWant"
                   :key="item.id">
                《<div class="book-name-middle overell"
                     @click.stop="goBookDetail(item.id)">{{item.bookName}}</div>》
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
<script>
import { getAccessToken } from '@/utils/userInfo'
// import PicZoom from '../../../common/pic-zoom'
export default {
  data () {
    return {
      totalPage: 1,
      currentPage: 1,
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1,
      tableStatus: true,
      headPhoto: this.$store.state.user.headPhoto,
      dataForm: {
        type: '',
        id: '',
        url: '',
        imgUrl: require('@/assets/img/占位图_en.png'),
        bookName: '',
        author: '',
        loseTime: '',
        endTime: '',
        currentPrice: '',
        bookPrice: '',
        salesVolumes: '',
        bookChapterList: [],
        bookCommentList: [],
        myreply: '',
        myCommentReply: '',
        commentId: null,
        subCommentList: [],
        bookLogoOssId: '',
        bought: '',
        free: '',
        bookType: '' // 实体书 电子书
      },
      imgUrl: require('@/assets/img/avatar-boy.gif'),
      imgUrl1: require('@/assets/img/bitmap_en.png'),
      pageIndex: 1,
      pageSize: 10,
      totalData: 0,
      which: '',
      SubId: '',
      currentIndex: 0,
      butLoading: false,
      customProps: {
        label: 'name',
        children: 'subList'
      },
      // 猜你想买
      maybeYouWant: [],
      migni: null, // 最外层DIV
      sLayer: null, // 左边小的图片容器
      bLayer: null, // 右边大的图片容器
      flt: null, // 跟随鼠标移动的浮动层
      smallImg: null, // 800*800的大图
      bigImg: null // 800*800的大图
    }
  },
  components: {
    // PicZoom
  },
  computed: {
    bookId () {
      return this.$route.query.id
    },
    isLogin () {
      return getAccessToken()
    }
  },
  watch: {
    bookId (val) {
      if (val) {
        this.getBookInfo()
        this.getBookComment(1)
      }
    }
  },
  mounted () {
    this.getBookInfo()
    this.getBookComment()
  },
  methods: {
    imgMouseover (e) {
      // 休正事件对象
      var evt = this.fixEvent(e)
      // 当鼠标在migni里快速的移动，鼠标会在flt和smallImg中快速切换，不断触发事件和事件冒泡间接的触发事件。需要屏蔽掉。
      if (evt.relatedTarget === this.flt || evt.relatedTarget === this.smallImg) {
        return false
      }
      let migni = document.getElementById('magnifier')
      let flt = migni.getElementsByTagName('span')[0] // 最外层DIV
      let bLayer = migni.getElementsByTagName('div')[1]
      flt.style.display = 'block'
      bLayer.style.display = 'block'
    },
    imgMouseout (e) {
      let evt = this.fixEvent(e)
      if (evt.relatedTarget === this.flt || evt.relatedTarget === this.smallImg) {
        return false
      }
      let migni = document.getElementById('magnifier')
      let flt = migni.getElementsByTagName('span')[0] // 最外层DIV
      let bLayer = migni.getElementsByTagName('div')[1]
      flt.style.display = 'none'
      bLayer.style.display = 'none'
    },
    imgMousemove (e) {
      this.migni = document.getElementById('magnifier') // 最外层DIV
      this.sLayer = this.migni.getElementsByTagName('div')[0] // 左边小的图片容器
      this.bLayer = this.migni.getElementsByTagName('div')[1] // 右边大的图片容器
      this.flt = this.migni.getElementsByTagName('span')[0] // 跟随鼠标移动的浮动层
      this.smallImg = this.sLayer.getElementsByTagName('img')[0] // 800*800的大图
      this.bigImg = this.bLayer.getElementsByTagName('img')[0] // 800*800的大图
      // 事件必须绑定在外层上，否则鼠标在 flt上移动，事件不会冒泡到migni上
      let evt = this.fixEvent(e)
      let l = evt.pageX - this.migni.offsetLeft - this.flt.offsetWidth / 2
      let t = evt.pageY - this.migni.offsetTop - this.flt.offsetHeight / 2
      // console.log(l, t)
      // 给 flt设置活动范围
      if (l < 0) {
        l = 0
      } else if (l > this.migni.offsetWidth - this.flt.offsetWidth) {
        l = this.migni.offsetWidth - this.flt.offsetWidth
      }
      if (t < 0) {
        t = 0
      } else if (t > this.migni.offsetHeight - this.flt.offsetHeight) {
        t = this.migni.offsetHeight - this.flt.offsetHeight
      }
      // console.log(l, t, '===')
      // 设置浮动层的位置
      this.flt.style.left = l + 'px'
      this.flt.style.top = t + 'px'
      // console.log(e.pageX);
      // 设置大图的位置。
      this.bigImg.style.left = -(l / this.smallImg.offsetWidth * this.bigImg.offsetWidth) + 'px'
      this.bigImg.style.top = -(t / this.smallImg.offsetHeight * this.bigImg.offsetHeight) + 'px'
    },
    fixEvent (evt) {
      var e = evt || window.event
      if (!e.target) { // IE
        if (e.type === 'mouseover') {
          e.relatedTarget = e.fromElement
        } else if (e.type === 'mouseout') {
          e.relatedTarget = e.toElement
        }
        e.pageX = document.documentElement.scrollLeft + e.clientX
        e.pageY = document.documentElement.scrollTop + e.clientY
      }
      return e
    },
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.getBookComment(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.getBookComment(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    changePageTo (page) {
      window.scrollTo(0, 0)
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [
            this.totalPage - 4,
            this.totalPage - 3,
            this.totalPage - 2,
            this.totalPage - 1,
            this.totalPage
          ]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
      // this.getBookComment()
    },
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        if (this.totalPage > 5) {
          if (
            this.jumpTargetPage > 2 && this.jumpTargetPage < this.totalPage - 4
          ) {
            var newPageList3 = []
            for (
              let index = this.jumpTargetPage - 2;
              index < this.jumpTargetPage + 3;
              index++
            ) {
              newPageList3.push(index)
            }
            this.pageList = newPageList3
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = '...'
          } else if (this.jumpTargetPage <= 2) {
            this.pageList = [1, 2, 3, 4, 5]
            this.currentPage = this.jumpTargetPage
            this.lastOmit = ''
            if (this.jumpTargetPage > this.totalPage - 3) {
              this.nextOmit = ''
            } else {
              this.nextOmit = '...'
            }
          } else {
            var newPageList4 = [
              this.totalPage - 4,
              this.totalPage - 3,
              this.totalPage - 2,
              this.totalPage - 1,
              this.totalPage
            ]
            this.pageList = newPageList4
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = ''
          }
        } else {
          var newPageList5 = []
          for (let index = 1; index <= this.totalPage; index++) {
            newPageList5.push(index)
          }
          this.pageList = newPageList5
          this.lastOmit = ''
          this.nextOmit = ''
          this.currentPage = this.jumpTargetPage
        }
        this.getBookComment()
        window.scrollTo(0, 0)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    reviewmore () {
      this.tableStatus = !this.tableStatus
    },
    routerHandle (routerName) {
      if (routerName === 'onlineTraining') {
        this.$router.push({ name: 'onlineTraining' })
      } else if (routerName === 'bookList') {
        this.$router.push({ name: 'bookList' })
      }
    },
    handleIndex (index) {
      this.currentIndex = index
      if (index === 2) {
        var comment = document.getElementById('toComment')
        document.documentElement.scrollTop = comment.offsetTop
      } else if (index === 0) {
        var introduce = document.getElementById('toIntroduce')
        document.documentElement.scrollTop = introduce.offsetTop
      } else {
        var review = document.getElementById('review')
        document.documentElement.scrollTop = review.offsetTop
      }
    },
    getBookInfo () {
      this.$http.get(`/front/train/trainBook/info/` + this.$route.query.id)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.dataForm.bookName = res.data.bookName
            this.dataForm.author = res.data.bookWriter
            this.dataForm.loseTime = res.data.loseTime
            this.dataForm.endTime = res.data.endTime
            this.dataForm.currentPrice = res.data.currentPrice
            this.dataForm.bookPrice = res.data.bookPrice
            this.dataForm.viewCount = res.data.viewCount
            this.dataForm.salesVolumes = res.data.salesVolumes
            this.dataForm.bookIntroduction = res.data.bookIntroduction
            this.dataForm.bookChapterList = res.data.bookChapterList
            this.dataForm.bookType = res.data.bookType
            this.dataForm.id = res.data.id
            this.dataForm.url = res.data.url
            this.dataForm.bookLogoOssId = res.data.bookLogoOssId
            this.maybeYouWant = res.data.guessLearnBookVos || []
            if (res.data.bookLogoOssId) {
              this.getUrl(res.data.bookLogoOssId)
            }
            this.dataForm.bought = res.data.bought
            this.dataForm.free = res.data.free
          } else {
            this.dataForm = null
            this.maybeYouWant = []
          }
        }).catch(() => {
          this.dataForm = null
          this.maybeYouWant = []
        })
    },
    // 图书预览
    reviewBook (data) {
      var free = data.isFree
      var id = data.ossId
      var playCount = data.playCount
      const { href } = this.$router.resolve({
        name: 'reviewbook',
        query: {
          id: id
        }
      })
      if (getAccessToken()) {
        if (this.dataForm.bookType === 1) {
          if (this.dataForm.bought || this.dataForm.free) {
            window.open(href, '_blank')
            this.addStudyHistory(data)
          } else if (free === 1) {
            window.open(href, '_blank')
          } else if (playCount) {
            window.open(href, '_blank')
          } else {
            this.$message({
              type: 'error',
              message: '该章节不是免费的,请购买后预览'
            })
          }
        }
      } else {
        this.$message({
          type: 'error',
          message: '用户信息不能为空,请先登录'
        })
      }
    },
    // 获取url
    getUrl (id) {
      this.$http.get(`/front/fileupload/alioss/showAliOssSvg/` + id)
        .then(({ data: res }) => {
          if (res.code === 0 && res.svgList && res.svgList[0]) {
            this.dataForm.url = res.svgList[0]
          }
        })
    },
    // 评论列表
    getBookComment (page = this.currentPage) {
      this.$http.post(`/front/train/trainComment/listBookCommentsAtDetailPage`, {
        'page': page,
        'limit': this.pageSize,
        'id': parseInt(this.$route.query.id)
      }).then(({ data: res }) => {
        if (res.code === 0) {
          this.dataForm.bookCommentList = res.data.data
          // 分页
          this.totalPage = Math.ceil(res.data.count / 10)
          this.changePageTo(page)
          this.dataForm.bookCommentList.forEach(item => {
            item.showContent = false
          })
          this.$nextTick(() => {
            this.$set(this.dataForm.bookCommentList, this.which, { ...this.dataForm.bookCommentList[this.which], showContent: true })
          })
        }
      })
    },
    // 展示评论框
    handleClick (id, index) {
      var show = !this.dataForm.bookCommentList[index].showContent
      this.$set(this.dataForm.bookCommentList, index, { ...this.dataForm.bookCommentList[index], showContent: show })
    },
    // 取消
    handleCancel (index) {
      this.$set(this.dataForm.bookCommentList, index, { ...this.dataForm.bookCommentList[index], showContent: false })
    },
    // 我来评价
    handleComment (id, index) {
      this.which = index
      this.$http.post(`/front/train/trainComment/saveBookComment`, {
        'content': id === '' ? this.dataForm.myreply : this.dataForm.myCommentReply,
        'businessId': parseInt(this.$route.query.id),
        'pCommentId': id
      }
      ).then(({ data: res }) => {
        if (res && res.code === 0) {
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.butLoading = false
              this.dataForm.myreply = ''
              this.dataForm.myCommentReply = ''
              this.getBookInfo()
              this.getBookComment()
            }
          })
        }
      })
    },
    // 点赞
    handleZan (id, type) {
      this.$http.post(`front/train/trainPraise/save`,
        {
          'targetId': id,
          'type': type
        })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$message({
              message: '点赞成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getBookInfo()
                this.getBookComment()
              }
            })
          }
        })
    },
    // 加入购物车
    addShopCart () {
      if (!this.isLogin) {
        this.pleaseLogin()
        return false
      }
      this.butLoading = true
      this.$http.post(`/front/train/trainShoppingCart/addGoodsToCart`, {
        'goodsCategory': this.dataForm.bookType === 1 ? 'doc' : 'realdoc',
        'goodsId': this.dataForm.id,
        'num': 1
      })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$router.push({ name: 'ShopCart' })
          }
        }).finally(() => {
          this.butLoading = false
        })
    },
    pleaseLogin () {
      this.$confirm(
        `请登录`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.$router.push({ name: 'login' })
        })
    },
    // 立即购买
    handleBuy () {
      if (!this.isLogin) {
        this.pleaseLogin()
        return false
      }
      this.$router.push({ name: 'settlement', query: { goodsId: '' + this.dataForm.id, type: this.dataForm.bookType === 1 ? 2 : 4 } })
    },
    // 分享返利
    share () {
      this.$confirm(
        `请登录掌上中控plantmate APP，享受分享返利`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => { })
    },
    addStudyHistory (chapter) {
      this.$http.post(`${window.SITE_CONFIG['trainURL']}/courseManagement/traincoursestudyhistory/save`, {
        'courseId': this.$route.query.id, // 课程id
        'chapterId': chapter.id, // 章节id
        'type': '2', // -- 1:课程 2:图书
        'courseName': this.dataForm.bookName, // -- 课程名称
        'chapterName': chapter.name // -- 章节名
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getBookInfo()
      this.getBookComment()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getBookInfo()
      this.getBookComment()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    // 显示点击的书
    goBookDetail (id) {
      this.$http.post(`/front/train/trainQuestionAnswe/plusViewCount`, {
        type: 3, // type --1:新闻/2：课程/3：图书/4：问答
        id: id
      })
      this.$router.push({ name: 'bookinfo', query: { id: id } })
    }
  }
}
</script>
<style scoped lang="scss">
.container {
  scroll-behavior: smooth;
}
body {
  // scroll-behavior: smooth
  transition: all 0.5s;
}
.book-info {
  width: 100%;
  height: 450px;
  background: #fff;
}
.book-img {
  float: left;
  width: 550px;
  height: 357px;
  // padding:10px;
}
#magnifier {
  width: 550px;
  height: 357px;
  // border:1px solid #eee;
  position: relative;
}
#magnifier span {
  width: 230px;
  height: 150px;
  background: url("/static/img/imgbg.png");
  position: absolute;
  display: none;
  cursor: move;
}
#magnifier .small_img {
  position: absolute;
  width: 550px;
  height: 357px;
  // background:red;
  font-size: 0; /* 休正IE 67 图片下方一个像素BUG*/
}
#magnifier .big_img {
  position: absolute;
  width: 690px;
  height: 450px;
  left: 600px;
  top: 0px;
  border: 1px solid #eee;
  display: none;
  overflow: hidden;
}
#magnifier .big_img img {
  display: block;
  position: absolute;
  left: 0;
  top: 0;
}
// #magnifier{
//   width:550px;
//   height:357px;
//   border:1px solid #eee;
//   position:relative;
// }
// #magnifier span{
//   width:230px;
//   height:150px;
//   background:url(http://img04.taobaocdn.com/tps/i4/T12pdtXaldXXXXXXXX-2-2.png);
//   position:absolute;
//   display:none;
//   cursor:move;
// }
// #magnifier .small_img{
//   position:absolute;
//   // background:red;
//   font-size:0; /* 休正IE 67 图片下方一个像素BUG*/
// }
// .small_img img{
//   width:550px;
//   height:357px;
// }
// #magnifier .big_img{
//   position:absolute;
//   width:1650px;
//   height:1071px;
//   left:550px;
//   top:0px;
//   border:1px solid #eee;
//   display:none;
//   overflow:hidden;
// }
// #magnifier .big_img img{
//   display:block;
//   position:absolute;
//   left:0;
//   top:0;
// }
.book-detail-one {
  float: left;
  width: 530px;
  height: 60px;
  background: #fff;
}
.book-detail-one ul {
  padding: 0 10px;
}
.book-detail-one ul li {
  float: left;
  width: 100px;
  height: 100px;
  text-align: center;
  // padding-top: 30px;
  color: #333;
  font-size: 16px;
}
.book-detail-one ul li .number {
  color: #1d65a8;
  font-weight: bold;
}

.book-detail-two {
  float: left;
  width: 630px;
  height: 357px;
  padding: 15px 15px 0 20px;
  background: #fff;
  margin-left: 10px;
}
.book-price {
  height: 50px;
  margin-top: 70px;
  padding-bottom: 20px;
  vertical-align: middle;
  color: #333;
  margin-bottom: 20px;
}
.book-author {
  margin-top: 15px;
}
.all-icon {
  float: left;
}
.book-main {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}
.book-show {
  width: 855px;
  padding: 20px;
  flex-grow: 0;
  flex-shrink: 0;
  // width: 100%;
  min-height: 648px;
  background: #fff;
  // padding: 5px 15px 20px 15px;
}
.show-title {
  margin: 20px 0;
  border-bottom: 1px solid #e2e2e2;
}
.show-content {
  padding-top: 20px;
  margin-left: 10px;
  margin-right: 10px;
  min-height: 648px;
  background: #fff;
}
.book-right-top {
  width: 100%;
  height: 180px;
  border-bottom: 1px solid #ccc;
  color: #333;
}
.book-right-top h2 {
  color: #333;
}
.shop {
  width: 300px;
  float: left;
}
.color-999 {
  color: #999;
}
.book-type {
  padding-top: 40px;
}
// 分享
.share {
  float: left;
  cursor: pointer;
  user-select: none;
}
// 图书简介
.show-title-list {
  background: #f8f8f8;
  border-bottom: 1px solid #1d65a8;
  height: 50px;
}
.show-title-list li {
  float: left;
  width: 100px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  cursor: pointer;
}
.show-checked {
  background: #1d65a8;
  color: #fff;
}
.book-introduce {
  width: 100%;
  min-height: 161px;
  height: auto;
}
.book-introduce h6 {
  font-weight: normal;
  margin-bottom: 10px;
}
.book-introduce span {
  border-left: 5px solid #333;
  color: #333;
  font-size: 16px;
  display: inline-block;
  line-height: 18px;
  padding-left: 10px;
}
.book-con {
  padding-left: 15px;
}
.book-detail {
  margin-top: 10px;
  margin-bottom: 10px;
  color: #999;
  padding: 0 50px;
  width: 600px;
}
.table-list {
  width: 50%;
  height: 135px;
}
.table-more-list {
  width: 50%;
}
.book-review {
  width: 100%;
  height: auto;
  min-height: 170px;
  margin-top: 20px;
}
.book-review h6 {
  font-weight: normal;
  margin-bottom: 10px;
}
.book-review h6 span {
  border-left: 5px solid #333;
  color: #333;
  font-size: 16px;
  display: inline-block;
  line-height: 18px;
  padding-left: 10px;
}
.book-comment {
  margin-top: 50px;
  min-height: 270px;
}
.book-comment h6 {
  font-weight: normal;
  margin-bottom: 10px;
}
.book-comment h6 span {
  border-left: 5px solid #333;
  color: #333;
  font-size: 16px;
  display: inline-block;
  line-height: 18px;
  padding-left: 10px;
}
.comment-info {
  margin-top: 20px;
}
// 评论
.comment-list ul ::after {
  content: "";
  clear: both;
  display: block;
  height: 0;
  overflow: hidden;
  visibility: hidden;
}
.comment-input {
  height: auto;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #ccc;
  margin-bottom: 30px;
}
.comment-input::after {
  content: "";
  clear: both;
  display: block;
  height: 0;
  overflow: hidden;
  visibility: hidden;
}
.comment-ava {
  width: 60px;
  height: 65px;
  float: left;
}
.comment-ava img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.comment-right {
  float: left;
  margin-left: 10px;
  width: 100%;
  height: auto;
  background: #fff;
}
.person {
  margin-bottom: 20px;
}
.comment-me {
  float: right;
  margin-top: 20px;
}
.comment-list-info {
  height: auto;
  width: 100%;
  border-bottom: 1px solid #ccc;
  padding: 10px 0;
}
.time {
  float: left;
}
.good {
  float: right;
  width: 140px;
  height: 30px;
  padding-left: 63px;
}
.commentImg {
  float: left;
  width: 15px;
  height: 15px;
}
.praiseImg {
  float: left;
  margin-left: 15px;
  width: 15px;
  height: 15px;
}
.commentShow {
  float: left;
  cursor: pointer;
}
.praiseShow {
  float: left;
  cursor: pointer;
}
.comment-show {
  margin-bottom: 5px;
}
.com-reply {
  float: left;
  width: 800px;
  height: auto;
}
.com-good {
  width: 100px;
  height: 100px;
  float: right;
  padding-top: 60px;
  cursor: pointer;
}
.com-good img {
  width: 15px;
  height: 15px;
}
.com-cont {
  margin-top: 5px;
  margin-bottom: 10px;
}
.train-p >>> img {
  max-width: 100% !important;
}
/* 分页区域样式 */
.doclist-pagination .pageactive {
  background: #1d65a8;
  color: #ffffff;
  border: 0;
}
.doclist-pagination {
  display: flex;
  height: 80px;
  padding: 20px 0;
  line-height: 40px;
  text-align: center;
  padding-left: 35px;
}
.doclist-pagination ul {
  display: flex;
}
.doclist-pagination ul li {
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
  cursor: pointer;
  border: 1px solid #eeeeee;
}
.doclist-omit {
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
}
.doclist-lastpage {
  font-size: 14px;
  color: #666666;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  padding: 0 26px;
}
.doclist-nextpage {
  font-size: 12px;
  color: #666666;
  margin-right: 34px;
  margin-left: 18px;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  padding: 0 26px;
}
.doclist-pagejump {
  height: 40px;
  color: #999999;
  font-size: 14px;
  margin-right: 46px;
}
.doclist-pagejump input {
  width: 35px;
  height: 40px;
  box-sizing: border-box;
  margin-left: 14px;
  margin-right: 8px;
  width: 34px;
  border: 1px solid #e4e4e4;
  text-align: center;
}
.doclist-jump {
  color: #666666;
  font-size: 14px;
  user-select: none;
  cursor: pointer;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  padding: 0 26px;
}
.doclist-lastpage {
  user-select: none;
  cursor: pointer;
}
.doclist-nextpage {
  user-select: none;
  cursor: pointer;
}
.pageDeavtive {
  box-sizing: border-box;
  border: 1px solid #eeeeee;
}
.bookreview {
  height: auto;
  cursor: pointer;
  padding-left: 10px;
}
.realbook {
  height: 46px;
  line-height: 46px;
  padding-left: 10px;
}
/* 右侧 */
.book-main .book-right {
  width: 315px;
  flex-grow: 1;
  flex-shrink: 1;
  margin-left: 20px;
}
.main-book {
  padding: 20px;
  width: 100%;
  background: #fff;
  margin-bottom: 20px;
}
.tarbar-item {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #333333;
  line-height: 22px;
  margin-bottom: 15px;
}
.tarbar-item .top-bg {
  height: 18px;
  width: 3px;
  background: #999999;
  background-color: #999999;
  margin-right: 10px;
}
.book-list .book-name {
  font-size: 14px;
  display: flex;
  user-select: none;
  cursor: pointer;
}
.book-list .book-name:hover {
  color: #1d65a8;
}
.no-content {
  text-align: center;
}
</style>
